import { createContext, useContext } from 'react';

export interface SimulationContextType {
  simId: string;
  label: string;
}

export const SimulationContext = createContext<SimulationContextType | undefined>(undefined);

export function useSimulationContext(): SimulationContextType {
  const context = useContext(SimulationContext);
  if (!context) {
    throw new Error(
      'useSimulationContext must be used within a SimulationContext provider (ParticipantLayout or OperatorLayout)',
    );
  }
  return context;
}
